import { store } from '@core/Store'
import { QUICKBET_MODAL_ID } from '@core/Areas/Quickbet/constants'
import { closeModal } from '@core/Components/Modal'
import { state$ as navState$ } from '@core/State/Navigation/driver'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { isSportRoute } from '../isRouteCheck/isRouteCheck'

export const navigateToLastSportsPath = () => {
  navState$.take(1).subscribe(navState => {
    store.dispatch(closeModal({ id: QUICKBET_MODAL_ID }))

    const lastSportPath = navState.get('lastSportPath')
    const currentUrlPath = navState.get('currentUrl')

    if (isSportRoute(currentUrlPath)) {
      const cleanedPathUrl = cleanPathUrl(currentUrlPath)
      const isMainPath = cleanedPathUrl === AppRoutes.Sports

      if (!isMainPath) {
        appHistory.push(AppRoutes.Sports)
        return
      }

      if (window.scrollY === 0) return
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    } else {
      // NOT in sport - Go to last used sport route
      appHistory.push(lastSportPath)
    }
  })
}

// =============
// Local Helpers
// =============

function cleanPathUrl(path: string) {
  return path.includes('?') ? path.slice(0, path.indexOf('?')) : path
}
